import React, { useState, useRef, useEffect, ReactNode } from 'react';
import {
  ExpandableMenu,
  EllipsisMenuButton,
} from '@grnhse/seedling/lib/birch/components/expandable_menu';
import { IconButton } from '@grnhse/seedling/lib/birch/components/buttons/icon_buttons';
import EllipsisIcon from '@grnhse/seedling/lib/birch/icons/ellipsis';
import styled from 'styled-components';
import Tokens from '@grnhse/seedling/lib/birch/tokens';

const Wrapper = styled.div`
  padding-top: ${Tokens.spacing['1']};
  height: 100%;
`;

type LazyEllipsisMenuProps = {
  ariaLabel: string;
  children: ReactNode;
};

const LazyEllipsisMenu = ({ ariaLabel, children }: LazyEllipsisMenuProps) => {
  const [menuMounted, setMenuMounted] = useState(false);
  const shouldOpenRef = useRef(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (menuMounted && shouldOpenRef.current) {
      shouldOpenRef.current = false;
      requestAnimationFrame(() => {
        const btn = wrapperRef.current?.querySelector(
          '[data-reach-menu-button]'
        ) as HTMLButtonElement | null;
        if (btn) {
          btn.dispatchEvent(
            new MouseEvent('mousedown', { bubbles: true, cancelable: true })
          );
        }
      });
    }
  }, [menuMounted]);

  const handleWrapperClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  const handlePlaceholderClick = () => {
    shouldOpenRef.current = true;
    setMenuMounted(true);
  };

  if (!menuMounted) {
    return (
      <Wrapper onClick={handleWrapperClick} onMouseUp={handleWrapperClick}>
        <IconButton
          icon={EllipsisIcon}
          label={ariaLabel}
          onClick={handlePlaceholderClick}
        />
      </Wrapper>
    );
  }

  return (
    <Wrapper
      ref={wrapperRef}
      onClick={handleWrapperClick}
      onMouseUp={handleWrapperClick}
    >
      {/* @ts-expect-error - TS2322 */}
      <ExpandableMenu dangerouslyBypassScrollLock>
        <EllipsisMenuButton aria-label={ariaLabel} />
        {children}
      </ExpandableMenu>
    </Wrapper>
  );
};

export default LazyEllipsisMenu;
